import React, { Fragment, ReactElement } from 'react';
import useStyles from './styles';
import { Control, DeepMap, FieldError, useForm } from 'react-hook-form';
import TranslatedText from 'components/atoms/translated_text';
import { Translations } from './configuration';
import {
  AppDatePicker,
  AppTextField,
} from 'components/molecules/form_controls';
import GridLayout from 'components/molecules/grid_layout';
import { Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import PaymentActions from 'redux/reducers/payment_list_reducer/actions';
import * as DateUtils from 'utils/dates';

interface IProps {
  payment_info_id: number;
  payment_reference: string;
  payment_date: Date;
}

interface FormFields {
  payment_reference: string;
  payment_date: Date | null;
}

export default function EditPaymentInfoForm(props: IProps): ReactElement {
  // console.log('Render EditPaymentInfoForm');
  const dispatch = useDispatch();
  const defaultValues = {
    payment_reference: props.payment_reference ?? null,
    payment_date: props.payment_date ? new Date(props.payment_date) : null,
  };

  const { errors, control, handleSubmit } = useForm<FormFields>({
    defaultValues,
  });
  const classes = useStyles();
  const [disable, setDisable] = React.useState(false);

  const onSubmit = (data: any) => {
    setDisable(true);
    dispatch(
      PaymentActions.updatePaymentInfoReferenceAction({
        payment_info_id: props.payment_info_id,
        // payment_reference: data.payment_reference,
        payment_date: DateUtils.convertToUtc(data.payment_date),
      })
    );
  };

  return (
    <form className={classes.form} noValidate onSubmit={handleSubmit(onSubmit)}>
      <GridLayout
        elements={[
          // {
          //   element: renderPaymentReferenceField(errors, control),
          //   size: 12,
          //   id: 'paymentReference',
          // },
          {
            element: renderPaymentDateField(errors, control),
            size: 12,
            id: 'paymentDate',
          },
          {
            element: (
              <Button
                variant="contained"
                color="primary"
                type="submit"
                style={{ width: '100%' }}
                disabled={disable}
              >
                <TranslatedText textMap={Translations.submit} />
              </Button>
            ),
            size: 12,
            id: 'action',
          },
        ]}
      />
    </form>
  );
}

const renderPaymentReferenceField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  return (
    <Fragment>
      <AppTextField
        variant="outlined"
        margin="normal"
        required
        fullWidth
        id="payment_reference"
        label={
          <TranslatedText textMap={Translations.payment_reference_control} />
        }
        error={'payment_reference' in errors}
        name="payment_reference"
        control={control}
        rules={{
          required: 'Required Field',
        }}
        helperText={
          errors.payment_reference && errors.payment_reference.message
        }
      />
    </Fragment>
  );
};

const renderPaymentDateField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  return (
    <AppDatePicker
      fullWidth
      margin="normal"
      label={<TranslatedText textMap={Translations.payment_date_control} />}
      error={'payment_date' in errors}
      control={control}
      rules={{
        required: 'Required Field',
      }}
      autoOk
      name="payment_date"
      helperText={errors.payment_date && errors.payment_date.message}
    />
  );
};
